export default {
  changeValue (context) {
    context.commit('changeValue')
  }
}
